import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import Sticky from 'react-stickynode'
import { Table } from '../table'
import TopSectionContainer from './top-section-container'
import Spacer from '../spacer'
import Button from '../button'
import { Grid, GridItem } from '../grid'
import PaginationInfo from './pagination-info'
import SearchResultTableHeader from './search-result-table-header'
import {
  getSelectedAddableDiamonds
} from '../../selectors/search'
import * as cartActions from '../../actions/cart'
import * as settingsActions from '../../actions/settings'
import * as actions from '../../actions/search'

export const mapStateToProps = (state, ownProps) => {
  return {
    ...state.diamondSearch,
    ...state.settings,
    colourType: state.diamondSearch.filters.colourType,
    matchedSets: state.diamondSearch.filters.matchedsets,
    addableDiamonds: getSelectedAddableDiamonds(state)
  }
}

export const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    onClickAddToListBtn: (diamonds) => {
      dispatch(cartActions.addDiamondsToCart(diamonds))
      dispatch(actions.clearCompareData())
      dispatch(settingsActions.showCart())
    },
    onClickCompareBtn: () => {
      dispatch(actions.openCompareModal())
    },
    onClickClearSelectedItemsBtn: () => {
      dispatch(actions.clearCompareData())
    }
  }
}

export class HeaderSection extends Component {
  render () {
    const props = this.props
    return (
      <Sticky enabled top={60} innerZ={1}>
        <TopSectionContainer>
          <Spacer xs />
          <Grid>
            <GridItem col='1/2'>
              <Button buttonId='compare-diamond-btn' disabled={props.selectedItems.length === 0 ? 'disabled' : ''} onClick={props.onClickCompareBtn}>
                Compare {props.selectedItems.length > 0 ? '(' + props.selectedItems.length + ')' : ''}
              </Button>
              <Button buttonId='add-to-list-btn' disabled={props.addableDiamonds.length === 0 ? 'disabled' : ''} onClick={props.onClickAddToListBtn.bind(this, props.addableDiamonds)}>
                Add to list {props.addableDiamonds.length > 0 ? '(' + props.addableDiamonds.length + ')' : ''}
              </Button>
              <Button buttonId='clear-selected-items-btn' disabled={props.selectedItems.length === 0 ? 'disabled' : ''} onClick={props.onClickClearSelectedItemsBtn}>
                Clear selected items
              </Button>
            </GridItem>
            <GridItem col='1/2'>
              <PaginationInfo pagination={props.pagination || {total_hits: 0, current_page: 0, hits_per_page: 0}} resultsTrueTotal={props.resultsTrueTotal} />
            </GridItem>
          </Grid>
          <Spacer xs />
          <Table>
            <SearchResultTableHeader markupType={props.markupType} currency={props.currency} colourType={props.colourType} matchedSets={props.matchedSets} />
          </Table>
        </TopSectionContainer>
      </Sticky>
    )
  }
}

HeaderSection.propTypes = {
  selectedItems: PropTypes.array.isRequired,
  addableDiamonds: PropTypes.array.isRequired,
  resultsTrueTotal: PropTypes.number.isRequired,
  pagination: PropTypes.object.isRequired,
  markupType: PropTypes.string.isRequired,
  currency: PropTypes.string.isRequired
}

export default connect(mapStateToProps, mapDispatchToProps)(HeaderSection)



// WEBPACK FOOTER //
// ./src/components/search-results/header-section.js